// extracted by mini-css-extract-plugin
module.exports = {"container":"_8c35a8f","textContainer":"_969ccf0","name":"_1c5e4b0","revert":"_17a935f","stack":"_c58a07d","iconContainer":"_03d1417","icon":"_eb046b6"};